/**
 * @generated SignedSource<<4c44e9c5f5ae3c268e81b9caca161a54>>
 * @relayHash d1a990f1bcd9708d3b6b3074bc4a9a41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4e255e32d1c9934d3c8bc35a592c5d2155ddccd366406829758d570afdcffd3d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBatchWindowPreference = "DEFAULT_BATCHING" | "FIFTEEN_MINUTES" | "FIVE_MINUTES" | "NO_BATCHING" | "ONCE_PER_DAY" | "ONE_DAY" | "ONE_HOUR" | "TEN_MINUTES" | "THIRTY_MINUTES" | "%future added value";
export type JiraEmailMimeType = "HTML" | "TEXT" | "%future added value";
export type JiraUpdateNotificationOptionsInput = {
  batchWindow?: JiraBatchWindowPreference | null | undefined;
  dailyBatchLocalTime?: string | null | undefined;
  emailMimeType?: JiraEmailMimeType | null | undefined;
  isEmailNotificationEnabled?: boolean | null | undefined;
  notifyOwnChangesEnabled?: boolean | null | undefined;
  notifyWhenRoleAssigneeEnabled?: boolean | null | undefined;
  notifyWhenRoleReporterEnabled?: boolean | null | undefined;
};
export type mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation$variables = {
  cloudId: string;
  input: JiraUpdateNotificationOptionsInput;
};
export type mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationOptions: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly options: {
        readonly " $fragmentSpreads": FragmentRefs<"mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation = {
  response: mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation$data;
  variables: mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "emailMimeType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isEmailMimeTypeEditable"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4e255e32d1c9934d3c8bc35a592c5d2155ddccd366406829758d570afdcffd3d",
    "metadata": {},
    "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7e95e63201e95d82104282c7ab474b5c";

export default node;
